<template>
  <div class="today_buy_wrapper mt15">
    <div class="today_buy_name_wrapper">
      <strong class="today_buy_name"><span class="icon-alarm_clock"></span>今日抢购</strong>
      <em class="today_buy_comment">小编每天帮您挑几款，总有一款适合您</em>
    </div>
    <div class="swiper-container today_goods_pic_wrapper">
      <div class="swiper-wrapper">
       <div class="swiper-slide today_pic_cell_wrapper" v-for="recommend in recommends" :key="recommend.id" >
         <div class="today_pic_cell">
           <img :src="recommend.picURL " class="today_goods_pic"  />
           <div class="today_coupon">
              <span class="coupon_text">券</span>
              <span class="circle"></span>
              <span class="coupon_money">{{recommend.money}}</span>
           </div>
         </div>
         <p class="today_btm_coupon">
           <span class="today_btm_coupon_text">券后</span><span class="today_btm_coupon_money">￥{{recommend.price}}</span>
         </p>
       </div>
   </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
  import Vue from 'vue'
  import SwiperVue from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  export default {
    name:"todayGrapBuy",
    data(){
      return {
        recommends:[]
      }
    },
    created:function(){


    },
    mounted(){

      this.login()

    },
    methods:{
      login () {
        let url ="api/getRecommends.php?page=1&pageSize=12"
        this.$ajax.autoService
            .login(url)
            .then((res) => {
              this.recommends = res.data;
              console.log(res.data)
              this.$nextTick(() => {
             var mySwiper = new SwiperVue('.swiper-container', {
               "autoplay": "true",
               "slidesPerView" : '3.4',
               'direction': 'horizontal',
                'loop': "true",
             })
           })
            }, (res) => {
                console.log("error")
            })
       },
    }
  }
</script>
<style lang="stylus">
   .today_buy_wrapper
     background:#fff
     padding-top:20px
     .today_buy_name_wrapper
       display:flex
       padding:0 15px 35px 30px
       justify-content: space-between
       .today_buy_name
         background-image: linear-gradient(to right, #f80, #f40)
         -webkit-background-clip: text
         -webkit-text-fill-color: transparent
         font-size:30px
         line-height:30px
         vertical-align: middle
        .today_buy_comment
           font-size:22px
           color:#666
           line-height:30px
           vertical-align: middle
      .swiper-container
        width:750px
        height:280px
        position:relative
        .today_pic_cell
          width:200px
          height:200px
          position:relative
        .today_goods_pic
          width:200px
          height:200px
        .today_coupon
          color:#fff
          position:absolute
          left:0px
          bottom:0px
          font-size:0px
          overflow:hidden
          .coupon_text
          .coupon_money
            display:inline-block
            padding:0 5px
            height:36px
            line-height:36px
            font-size:22px
            vertical-align:middle
          .coupon_text
            background:#ff6500
            position:relative
            border-radius:5px 0 0 5px
          .coupon_money
            background:#ff5400
            border-radius:0 5px 5px 0
          .circle
            width:13px
            height:36px
            background:url(../../images/jrqg_coupon_bg.png)no-repeat left top
            background-size:14px 36px
            display:inline-block
            vertical-align:middle
      .today_btm_coupon
        width:200px
        margin-top:15px
        line-height:30px
        text-align:center
        .today_btm_coupon_text
          color:#999
          font-size:24px
          vertical-align:middle
        .today_btm_coupon_money
          color:#f40
          font-size:30px
          vertical-align:middle




</style>



// WEBPACK FOOTER //
// src/components/goodsCoupon/todayGrapBuy.vue